<template>
    <div>
        <app-header :items="navItems" :mobile-items="mobileNavItems" fluid flat fixed class="bg-white"/>
        <app-content>
            <page-content without-mobile-bottom-bar>
                <container tight>
                    <div class="flex flex-column items-center justify-center w-full">
                        <cdn-image :src="logo.path" :size="{height: 72, ratio: logo.ratio, md: {width: 96}}" alt="SPOFERAN Guide" class="mb-16 lg:mb-32 lg:mt-16 xl:mt-32"/>
                        <h1 class="text-3xl sm:text-4xl lg:text-6xl text-center">SPOFERAN Guide</h1>
                        <p class="text-md sm:text-lg lg:text-xl text-center font-heading text-subtext-color md:mb-48 px-16">Anleitungen, Tipps und Tricks für SPOFERAN und
                            resultastic.</p>

                        <row class="w-full">
                            <column v-for="area in areas" :key="area.id" cols="12" sm="6">
                                <card :to="$app('area', {params: {area: area._key}, state: {area_ts: $date(area.updated_at).unix()}})">
                                    <card-image :src="area.image" alt="SPOFERAN" :size="{width: '100vw', ratio: 4/2, sm: {width: 360}}"/>

                                    <card-title>{{ area.title }}</card-title>

                                    <card-text class="sm:text-md">{{ area.description }}</card-text>

                                    <card-buttons stretch>
                                        <btn color="primary">Los geht`s!</btn>
                                    </card-buttons>
                                </card>
                            </column>
                        </row>
                    </div>

                    <divider/>
                    <app-plain-footer class="mb-24"/>
                </container>
            </page-content>
        </app-content>
    </div>
</template>

<script setup lang="ts">
import {Images} from "@spoferan/spoferan-ts-core";
import {externalLinkIcon} from "@spoferan/nuxt-spoferan/icons";
const {$web, $image} = useNuxtApp();
const config = useRuntimeConfig();
const {data: areas} = await useApiFetch('/v1/guide', {
	guest: true
});

const navItems = [
	...areas.map(area => {
		return {to: $web('areas.show', area._key), text: area.title};
	}),
	{href: config.public.spoferanUrl + '/support', text: 'Support'},
	{href: config.public.spoferanUrl, text: 'SPOFERAN.com', text_icon: externalLinkIcon}
];

const mobileNavItems = [{href: config.public.spoferanUrl, text: 'SPOFERAN.com', text_icon: externalLinkIcon}];

const logo = Images.favicon;

</script>